/**
 * Generic 4th-order Runge-Kutta integrator.
 *
 * Works on a flat number array state vector.
 * The derivative function maps (time, state) -> dState.
 */
export function rk4Step(
  t: number,
  state: number[],
  dt: number,
  derivFn: (t: number, state: number[]) => number[],
): number[] {
  const n = state.length;
  const k1 = derivFn(t, state);

  const s2 = new Array<number>(n);
  for (let i = 0; i < n; i++) s2[i] = state[i] + dt * 0.5 * k1[i];
  const k2 = derivFn(t + dt * 0.5, s2);

  const s3 = new Array<number>(n);
  for (let i = 0; i < n; i++) s3[i] = state[i] + dt * 0.5 * k2[i];
  const k3 = derivFn(t + dt * 0.5, s3);

  const s4 = new Array<number>(n);
  for (let i = 0; i < n; i++) s4[i] = state[i] + dt * k3[i];
  const k4 = derivFn(t + dt, s4);

  const result = new Array<number>(n);
  for (let i = 0; i < n; i++) {
    result[i] = state[i] + (dt / 6) * (k1[i] + 2 * k2[i] + 2 * k3[i] + k4[i]);
  }

  return result;
}
